export const en = {
    "create-alice-agent": "Create Internal Agent",
    "create-alice-app": "Create agent",
    "new-alice-agent": "New agent",
    "create-error": "Failed to create agent",

    "side-menu-settings": "Settings",
    "agent-fallback-title": "Agent",

    "status-published": "Published",
    "status-draft": "Draft",

    "version-draft": "Draft",
    "version-published": "Published version",
    "version-unpublished-title": "Unpublished",

    "field-name": "Name",
    "field-name-placeholder": "Name the user will see",

    "field-agent-name": "Internal agent name",
    "field-agent-name-description": "Agent's system identifier — the same name that's registered in the Alice agents registry.",
    "field-agent-name-placeholder": "e.g. my-registered-agent",

    "field-title": "Localized name",
    "field-title-description": "Localized name shown to the user.",

    "field-short-description": "Short description",
    "field-short-description-description": "Localized blurb shown to the user under the agent.",

    "field-aliases": "Aliases",
    "field-aliases-description": "Short names for quickly invoking the agent via [@] or [/].",
    "field-aliases-placeholder": "e.g. agent-alias",
    "field-aliases-add": "Add",

    "field-placement": "Placement",
    "field-available-in-plus-menu": "Show in the \"+\" menu",

    "field-access": "Access",
    "field-available-without-login": "Available without login on Yandex",

    "field-chat-testing": "Testing",
    "field-chat-testing-label": "Available for testing",

    "action-save": "Save",
    "action-publish": "Publish",

    "toast-saved": "Saved",
    "toast-save-error": "Failed to save",
    "toast-published": "Published",
    "toast-publish-error": "Failed to publish",

    "field-logo": "Logo",
    "upload-label": "Logo",
    "upload-drop-here": "Drop here",
    "upload-format-error": "Unsupported file format. Use PNG or JPEG.",
    "upload-error": "Failed to upload logo",
    "toast-logo-uploaded": "Logo uploaded",

    "list-load-error": "Failed to load the list of agents",
    "access-manager-title": "Manage agent administrators",
    "access-manager-guid-label": "Agent app GUID",
    "access-manager-guid-placeholder": "Enter agent app GUID",
    "access-manager-open": "Open",
    "access-manager-login-label": "Administrator login",
    "access-manager-login-placeholder": "Enter Yandex login",
    "access-manager-grant": "Grant access",
    "access-manager-revoke": "Revoke",
    "access-manager-list-title": "Administrators",
    "access-manager-empty": "No additional administrators",
    "access-manager-load-error": "Failed to load agent administrators",
    "access-manager-grant-error": "Failed to grant administrator access",
    "access-manager-revoke-error": "Failed to revoke administrator access",
    "card-owner-login": "Owner: {login}",
    "card-type-internal": "Internal Agent",
    "card-type-external": "External Agent",
    "card-published-on": "Published {date}",

    "validation-required": "Required field",
    "validation-agent-name-format": "Allowed: Latin letters, digits, dashes, underscores",
    "toast-form-invalid": "Form has errors. Check the highlighted fields."
} as const;

export const ru = {
    "create-alice-agent": "Создать внутреннего агента",
    "create-alice-app": "Создать агента",
    "new-alice-agent": "Новый агент",
    "create-error": "Не удалось создать агента",

    "side-menu-settings": "Настройки",
    "agent-fallback-title": "Агент",

    "status-published": "Опубликован",
    "status-draft": "Черновик",

    "version-draft": "Черновик",
    "version-published": "Опубликованная версия",
    "version-unpublished-title": "Снято с публикации",

    "field-name": "Название",
    "field-name-placeholder": "Имя агента, которое увидит пользователь",

    "field-agent-name": "Внутреннее имя агента",
    "field-agent-name-description": "Системный идентификатор агента, соответствующий имени из registry агентов Alice.",
    "field-agent-name-placeholder": "например, my-registered-agent",

    "field-title": "Локализованное название",
    "field-title-description": "Локализованное название, которое увидит пользователь.",

    "field-short-description": "Короткое описание",
    "field-short-description-description": "Локализованное описание, которое увидит пользователь под агентом.",

    "field-aliases": "Алиасы",
    "field-aliases-description": "Короткие имена для быстрого вызова агента через [@] или [/].",
    "field-aliases-placeholder": "например, agent-alias",
    "field-aliases-add": "Добавить",

    "field-placement": "Размещение",
    "field-available-in-plus-menu": "Показывать в меню по кнопке \"+\"",

    "field-access": "Доступ",
    "field-available-without-login": "Доступен без авторизации на Яндекс",

    "field-chat-testing": "Тестирование",
    "field-chat-testing-label": "Доступен для тестирования",

    "action-save": "Сохранить",
    "action-publish": "Опубликовать",

    "toast-saved": "Сохранено",
    "toast-save-error": "Не удалось сохранить",
    "toast-published": "Опубликовано",
    "toast-publish-error": "Не удалось опубликовать",

    "field-logo": "Логотип",
    "upload-label": "Логотип",
    "upload-drop-here": "Сюда",
    "upload-format-error": "Неподдерживаемый формат. Используйте PNG или JPEG.",
    "upload-error": "Не удалось загрузить логотип",
    "toast-logo-uploaded": "Логотип загружен",

    "list-load-error": "Не удалось загрузить список агентов",
    "access-manager-title": "Управление администраторами агента",
    "access-manager-guid-label": "GUID приложения агента",
    "access-manager-guid-placeholder": "Введите GUID приложения агента",
    "access-manager-open": "Открыть",
    "access-manager-login-label": "Логин администратора",
    "access-manager-login-placeholder": "Введите логин на Яндексе",
    "access-manager-grant": "Выдать доступ",
    "access-manager-revoke": "Отозвать",
    "access-manager-list-title": "Администраторы",
    "access-manager-empty": "Дополнительных администраторов нет",
    "access-manager-load-error": "Не удалось загрузить администраторов агента",
    "access-manager-grant-error": "Не удалось выдать права администратора",
    "access-manager-revoke-error": "Не удалось отозвать права администратора",
    "card-owner-login": "Владелец: {login}",
    "card-type-internal": "Внутренний агент",
    "card-type-external": "Внешний агент",
    "card-published-on": "Опубликован {date}",

    "validation-required": "Обязательное поле",
    "validation-agent-name-format": "Допустимы: латинские буквы, цифры, дефис, подчёркивание",
    "toast-form-invalid": "В форме есть ошибки. Проверьте подсвеченные поля."
} as const;
